import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { chatsService } from '../../services/api'
import { messagingPaths } from '../../utils/messagingPaths'
import { useAuth } from '../../context/AuthContext'

export default function MessagingLegacyRedirect() {
  const { conversationId } = useParams()
  const { user } = useAuth()
  const [target, setTarget] = useState(null)

  useEffect(() => {
    let cancelled = false

    const resolve = async () => {
      try {
        const res = await chatsService.getChatById(conversationId)
        const chat = res?.data ?? res
        if (cancelled) return
        setTarget(messagingPaths.chatFromRecord(chat, user?.id))
      } catch {
        if (!cancelled) {
          setTarget(messagingPaths.chat({ chatId: conversationId }))
        }
      }
    }

    resolve()
    return () => { cancelled = true }
  }, [conversationId, user?.id])

  if (!target) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900" />
      </div>
    )
  }

  return <Navigate to={target} replace />
}
